var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedBigWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 1.24316,
    y: 0.875,
    width: 38.25,
    height: 38.25,
    rx: 19.125,
    stroke: "white",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.0347 13.333L17.7013 26.6663L11.0347 19.9997",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBigWhite);
export default __webpack_public_path__ + "static/media/checked-big-white.c5f7c29c850978e3324db5eacbab9987.svg";
export { ForwardRef as ReactComponent };